<tp-marketplace-integration providerName="GCP" [isSubmitting$]="isSubmitting$" (setAccount)="setGCPAccount($event.team, $event.token)"/>
